// Classifica o evento `message` que a janela do Embedded Signup da Meta manda ao popup.
// Devolve null para qualquer coisa que não seja um evento WA_EMBEDDED_SIGNUP válido.
export const classifyMetaEvent = (raw) => {
  if (typeof raw !== "string") return null;
  let data;
  try { data = JSON.parse(raw); } catch (e) { return null; }
  if (!data || data.type !== "WA_EMBEDDED_SIGNUP") return null;
  const d = data.data || {};
  // FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING = coexistência (número que segue no app WhatsApp Business)
  if (data.event === "FINISH" || data.event === "FINISH_ONLY_WABA" || data.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING") {
    if (data.event === "FINISH_ONLY_WABA" || !d.phone_number_id || !d.waba_id) return { kind: "only_waba" };
    return { kind: "finish", ids: { wabaId: String(d.waba_id), phoneNumberId: String(d.phone_number_id), businessId: d.business_id ? String(d.business_id) : undefined } };
  }
  if (data.event === "CANCEL") return { kind: "cancel" };
  if (data.event === "ERROR") return { kind: "error", message: d.error_message || "" };
  return null;
};
